var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoffeeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "103px",
    height: "98px",
    viewBox: "0 0 103 98",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-tertiary-daily-tea+coffee") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "84.3774568%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "94.5123255%",
    y1: "74.0025688%",
    x2: "19.6413923%",
    y2: "17.7233958%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.10968351,22.6186488 L58.9882221,22.6186488 C59.2949294,22.6186488 59.5435649,22.8672842 59.5435649,23.1739916 C59.5435649,23.1960471 59.5422509,23.2180831 59.5396301,23.2399824 L54.0983427,68.7064771 L54.0983427,68.7064771 C53.9667689,69.1818733 53.7310936,69.4412095 53.3913168,69.4844857 C44.9084318,70.5649216 37.4286512,70.8062049 31.0489528,70.8062049 C24.6873572,70.8062049 16.8906303,70.0686403 8.77905058,69.491976 C8.39229204,69.4644808 8.12843901,69.1690256 7.98749149,68.6056104 L2.55827547,23.2399824 C2.52182977,22.9354481 2.73915848,22.6590292 3.04369273,22.6225835 C3.06559201,22.6199627 3.08762797,22.6186488 3.10968351,22.6186488 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.6%",
    y: "-2.1%",
    width: "103.3%",
    height: "108.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2.5,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 5,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "0.000123416691 0.00676935824 14.1909297 0.00676935824 14.1909297 7.20406206 0.000123416691 7.20406206"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0003815,0 C39.2008719,0 47.4013623,0.482710469 55.6018526,1.44813141 C56.5918909,1.56470822 57.3830375,2.32654127 57.5368712,3.31147841 L58.3090269,8.26 L58.7047557,8.2607239 C59.7692858,8.2607239 60.632258,9.12369605 60.632258,10.1882261 C60.632258,10.728095 60.4103068,11.2161243 60.0526755,11.5660433 L60.2913606,11.5650135 C60.500496,11.5650135 60.6918976,11.6825054 60.7865587,11.8689909 L61.3409524,12.9611651 C61.4797777,13.2346554 61.37061,13.5689032 61.0971197,13.7077284 C61.0192276,13.7472669 60.933107,13.7678732 60.8457544,13.7678732 L0.595916604,13.7678732 C0.289209254,13.7678732 0.0405738211,13.5192377 0.0405738211,13.2125304 C0.0405738211,13.1251778 0.0611801038,13.0390572 0.100718577,12.9611651 L0.655112334,11.8689909 C0.749773451,11.6825054 0.94117503,11.5650135 1.15031036,11.5650135 L1.94808756,11.5660433 C1.59045618,11.2161243 1.36850502,10.728095 1.36850502,10.1882261 C1.36850502,9.12369605 2.23147717,8.2607239 3.29600727,8.2607239 L3.69002692,8.26 L4.46389084,3.31148464 C4.61771506,2.32653038 5.40887389,1.56468556 6.39893014,1.44812908 C14.5994139,0.482709693 22.7998977,0 31.0003815,0 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.6%",
    y: "-7.3%",
    width: "103.1%",
    height: "128.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-8"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2.5,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 5,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "47.919324%",
    x2: "100%",
    y2: "47.919324%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "50%",
    fx: "50%",
    fy: "50%",
    r: "649.428258%",
    gradientTransform: "translate(0.500000,0.500000),scale(1.000000,0.071985),rotate(90.000000),scale(1.000000,0.050872),translate(-0.500000,-0.500000)",
    id: "radialGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "75.4740169%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "47.919324%",
    x2: "100%",
    y2: "47.919324%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "40.7435098%",
    y2: "21.5777229%",
    id: "linearGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-12.8%",
    y: "-10.2%",
    width: "125.5%",
    height: "120.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-14"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.649945644,
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HH---Complete-the-assessments-and-reveal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Employer-Dashboard-LG-03.7.0-Copy-3",
    transform: "translate(-594.000000, -1475.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-tertiary-daily-tea+coffee",
    transform: "translate(594.000000, 1475.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "coffee"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.48391622,13.2761634 L59.6139894,13.2761634 L50.7684346,85.2319434 C50.5384777,85.9120361 50.1296028,86.3222962 49.5418097,86.4627239 C43.3967382,87.9308223 18.7482085,87.930984 12.6212187,86.4767996 C11.9900104,86.3269881 11.5576319,85.8968189 11.3240832,85.186292 L2.48391622,13.2761634 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-2)",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(18.174997, 34.422241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4708723,20.6474138 C22.3642051,20.8657561 22.2763273,21.0688669 22.1691815,21.2611666 C21.3472515,22.736189 19.9981308,23.4361269 18.4228301,23.7643222 C16.6496093,24.1337409 14.9254781,23.8895583 13.2525019,23.233496 C12.0262941,22.7526329 10.9326963,22.0608286 10.0136449,21.1079179 C9.2070287,20.2715793 8.58871108,19.3196285 8.32432231,18.1725741 C8.23994559,17.8065654 8.22576526,17.4242139 8.18120932,17.0491372 C8.17790981,17.0213266 8.18874026,16.9918489 8.1943066,16.9544397 C8.98623876,16.8119262 9.76089259,16.5752204 10.5769792,16.592321 C12.2289745,16.6269264 13.6116445,17.2571483 14.6980388,18.5005926 C15.6716705,19.6149361 16.8459174,20.3942894 18.2760146,20.7732814 C19.3408739,21.0555046 20.4143221,21.0718222 21.4921024,20.8444371 C21.8059082,20.7782323 22.1209231,20.7176602 22.4708723,20.6474138",
    id: "Fill-1",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3401537,12.3750603 C19.4646508,11.892227 18.5222762,11.5325079 17.7771165,10.837142 C17.3025919,10.3943448 16.9047368,9.89297108 16.6086123,9.3146067 C16.2027225,8.52186583 15.9947276,7.68191515 15.9724622,6.78641906 C15.9349586,5.27752381 15.4494525,3.91813892 14.536169,2.71657474 C13.8491914,1.81271779 12.9801364,1.13298745 11.9639133,0.637347594 C11.8815515,0.597185155 11.8015322,0.552172912 11.7204298,0.509434015 C11.7171554,0.496198092 11.7138559,0.482936909 11.7105816,0.469700986 C11.9694292,0.372553351 12.223315,0.258330364 12.4879808,0.181238689 C13.5015341,-0.113967867 14.5061208,-0.0291215571 15.4963256,0.295411157 C16.7860804,0.718127141 17.8656994,1.47244847 18.788554,2.45551888 C20.0875777,3.83930435 20.9418478,5.46118488 21.3034587,7.33108741 C21.5381016,8.54449825 21.5056606,9.74929564 21.1154624,10.933153 C20.9547184,11.4208361 20.6317445,12.0322651 20.3401537,12.3750603",
    id: "Fill-3",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(8.513233, 12.368288)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000123416691,3.05590693 C0.21252606,2.56723866 0.490213615,2.1452552 0.845427001,1.7753061 C1.48553145,1.10863487 2.2597319,0.655127682 3.13432806,0.382730361 C3.54276175,0.255498786 3.96598025,0.160169827 4.38950099,0.0999261687 C6.65155263,-0.222004827 8.73799994,0.303415859 10.6737781,1.47550233 C11.8113526,2.16425027 12.7542309,3.06303008 13.4320908,4.22155226 C13.8606238,4.95394843 14.1284884,5.73883363 14.1894411,6.59090882 C14.1982062,6.71364422 14.170853,6.76449138 14.0415426,6.78906877 C13.4117145,6.90864675 12.7891402,7.0805622 12.1548036,7.15939677 C10.694633,7.34093605 9.36447818,6.96694544 8.19244779,6.07650123 C7.87070804,5.83206606 7.5756414,5.54218923 7.3079783,5.23809137 C6.12247283,3.89131092 4.65096807,3.08907252 2.87658867,2.84938611 C2.04866418,2.73756277 1.22756537,2.79356285 0.41392195,2.97757754 C0.295366366,3.00440302 0.176080356,3.02814685 0.057046217,3.0528758 C0.045686844,3.05525019 0.0336222328,3.05429033 0.000123416691,3.05590693",
    id: "Fill-5",
    fill: "#FFFFFF",
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.23955442,17.8746521 C1.08087582,17.6655548 0.90857101,17.4653741 0.765986951,17.2457942 C0.235345555,16.4285517 0.0119361571,15.5204007 0.000501222887,14.5528648 C-0.0136539159,13.3551148 0.27410847,12.2261461 0.79334012,11.1560571 C1.73118103,9.2233344 3.14286648,7.7399764 5.03640595,6.7279082 C5.86972048,6.28250928 6.75716205,5.99798745 7.6992344,5.89601527 C7.73260728,5.89242843 7.76605572,5.88899315 7.79955454,5.88691112 C7.81159396,5.8862904 7.82388525,5.89005405 7.84698181,5.89333777 C7.87015392,6.0869763 7.8900769,6.28218091 7.91732932,6.47637514 C8.07532787,7.60185802 8.41114721,8.6728564 8.91305015,9.69063322 C8.97362507,9.8134444 8.96778167,9.89202638 8.88476505,10.0012985 C8.16350784,10.9511023 7.24012431,11.6081497 6.10650422,11.975093 C4.67295639,12.4391333 3.50420033,13.2805238 2.60940413,14.4953997 C1.94756324,15.3939521 1.534747,16.4015242 1.34957159,17.5031622 C1.32957305,17.6220834 1.30164058,17.7396659 1.27738542,17.8578799 C1.26476669,17.8634622 1.25214796,17.8690445 1.23955442,17.8746521",
    id: "Fill-8",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0948638,11.1184054 C15.7243367,11.0721807 15.3722969,11.0214346 15.0187459,10.9854147 C13.9200854,10.8734903 12.8345475,10.9584882 11.7640462,11.2270966 C11.6608548,11.2529875 11.6052669,11.2288647 11.5413421,11.1522277 C10.5004608,9.90421151 9.78079038,8.49539399 9.43552589,6.90246073 C9.16740943,5.66525553 9.16247276,4.43151088 9.53602234,3.21110318 C9.73139852,2.57279826 10.0361622,1.99218579 10.4812683,1.47085713 C10.6473267,1.5573453 10.8165083,1.63822588 10.9786879,1.73130675 C11.4256326,1.98779066 11.8972607,2.21174046 12.3096236,2.51601514 C13.5513718,3.43217341 14.2811674,4.67377374 14.4955598,6.20666542 C14.554825,6.63036652 14.5528101,7.06232744 14.5939406,7.48903441 C14.6651193,8.22759387 14.8690842,8.93124486 15.1673244,9.60971222 C15.4050653,10.1505664 15.7196519,10.6425689 16.0948638,11.1184054",
    id: "Fill-10",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.77660932,11.1893995 C9.92148541,11.3860186 10.0672682,11.5838502 10.2163506,11.7861779 C9.68999096,12.0506185 9.20576935,12.3643908 8.76335829,12.7437364 C7.98711768,13.4092962 7.45685409,14.2391431 7.06134138,15.177858 C6.86243901,15.6499308 6.74667919,16.1186695 6.76425977,16.627621 C6.77443535,16.9216656 6.73569762,17.2196002 6.76886901,17.510058 C6.81397907,17.905317 6.90681864,18.2950947 6.97892925,18.6872469 C6.98041529,18.6952794 6.97913075,18.7038423 6.97913075,18.7384982 C6.74557096,18.812584 6.50878722,18.911424 6.26218052,18.9607303 C5.81095399,19.0509569 5.35630201,19.1428506 4.8988039,19.178138 C4.14112616,19.2365629 3.39924073,19.1293621 2.68856209,18.8417333 C2.58980355,18.801773 2.5468092,18.7659551 2.57559803,18.6425125 C2.71100377,18.0619253 2.7819054,17.4611053 2.96904541,16.8987048 C3.55864976,15.1269603 4.75909116,13.9350705 6.52533513,13.3418283 C7.77637739,12.921613 8.84574523,12.2412007 9.71145035,11.2414843 C9.72243192,11.2288041 9.73369054,11.2162502 9.74600702,11.2049592 C9.75185043,11.1996295 9.76048959,11.1973814 9.77660932,11.1893995",
    id: "Fill-12",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.2005423,35.1354632 C42.6202011,32.2711136 37.1785952,30.443025 31.0849466,30.443025 C24.9568908,30.443025 19.4882618,32.2918161 15.908881,35.184082",
    id: "Oval",
    stroke: "#D9D9D9",
    strokeWidth: 1.18723404,
    strokeDasharray: "1.110685694217682,1.110685694217682"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2005423,63.0605864 C42.6202011,60.1962367 37.1785952,58.3681482 31.0849466,58.3681482 C24.9568908,58.3681482 19.4882618,60.2169393 15.908881,63.1092052",
    id: "Oval",
    stroke: "#D9D9D9",
    strokeWidth: 1.18723404,
    strokeDasharray: "1.110685694217682,1.110685694217682",
    transform: "translate(31.054712, 60.738677) rotate(-180.000000) translate(-31.054712, -60.738677) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-8)",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#575756",
    fillRule: "evenodd",
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#linearGradient-9)",
    opacity: 0.200000003,
    transform: "translate(30.800561, 8.359066) rotate(-90.000000) translate(-30.800561, -8.359066) ",
    cx: 30.8005612,
    cy: 8.35906585,
    rx: 1.47512927,
    ry: 27.3230785
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#radialGradient-10)",
    opacity: 0.200000003,
    transform: "translate(30.800561, 9.834195) rotate(-90.000000) translate(-30.800561, -9.834195) ",
    cx: 30.8005612,
    cy: 9.83419512,
    rx: 1.96683902,
    ry: 27.3230785
  })), /*#__PURE__*/React.createElement("g", {
    id: "tea",
    transform: "translate(22.531250, 46.218750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.05078879,2.7639662 C11.6742563,0.921322068 20.6116506,0 31.8629718,0 C43.114291,0 52.0516841,0.921321722 58.6751512,2.76396516 L58.6751525,2.76396028 C61.4874805,3.54634776 63.4331855,6.10774922 63.4326231,9.026879 C63.4271419,37.4771498 52.9039248,51.7022851 31.8629718,51.7022851 C10.8220173,51.7022851 0.298800254,37.4771477 0.293320588,9.02687288 L0.293327511,9.02687288 C0.292765273,6.10774881 2.23846636,3.54635239 5.05078879,2.7639662 Z",
    id: "Path-23",
    fill: "url(#linearGradient-11)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#62EBB9",
    cx: 32.1552835,
    cy: 5.22832097,
    rx: 28.3542257,
    ry: 3.48554731
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#linearGradient-12)",
    opacity: 0.200000003,
    transform: "translate(31.862972, 4.937859) rotate(-90.000000) translate(-31.862972, -4.937859) ",
    cx: 31.8629718,
    cy: 4.93785869,
    rx: 3.48554731,
    ry: 28.3542257
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6583251,15.1364937 C82.1250977,21.1261263 78.6583251,31.0320571 63.8667619,36.7913192 C61.7866983,37.7128012 61.7866983,41.8594699 55.5465076,41.1683584 C51.3863805,40.7076175 53.8563292,30.9547277 62.956354,11.909689 C71.113153,10.0678038 76.3471434,11.1434053 78.6583251,15.1364937 Z M75.3524351,17.5722644 C73.4332542,14.9398844 67.3335345,15.3668642 65.9468255,16.5187166 C64.5601164,17.670569 60.3999893,31.7231686 65.253471,31.7231686 C71.0314253,30.8016866 77.2716161,20.2046444 75.3524351,17.5722644 Z",
    id: "Combined-Shape",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1565357,13.9421892 L48.68223,16.9924489 C48.8202017,17.08544 48.9172564,17.2278034 48.9534018,17.3902136 L52.2764651,32.3215589 C52.3544449,32.6719414 52.1336188,33.0191977 51.7832363,33.0971775 C51.7368798,33.1074944 51.6895322,33.1126995 51.6420414,33.1126995 L41.122304,33.1126995 C40.8177528,33.1126995 40.5540414,32.9012266 40.4878804,32.6039487 L37.1607325,17.6542504 C37.0937411,17.3532414 37.2474908,17.046594 37.5287744,16.9202064 L44.1565357,13.9421892 Z M44.1565357,17.4277366 C43.5019991,17.4277366 42.9713924,18.0779585 42.9713924,18.8800479 C42.9713924,19.6821374 43.5019991,20.3323593 44.1565357,20.3323593 C44.8110722,20.3323593 45.3416789,19.6821374 45.3416789,18.8800479 C45.3416789,18.0779585 44.8110722,17.4277366 44.1565357,17.4277366 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-13)",
    filter: "url(#filter-14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6785012,13.3612647 L47.9279687,16.6557424 C48.1174167,16.7746368 48.2324218,16.9825891 48.2324218,17.2062551 L48.2324218,28.9772065 C48.2324218,29.3361616 47.9414312,29.6271522 47.5824761,29.6271522 L37.7745264,29.6271522 C37.4155713,29.6271522 37.1245807,29.3361616 37.1245807,28.9772065 L37.1245807,17.2062551 C37.1245807,16.9825891 37.2395858,16.7746368 37.4290338,16.6557424 L42.6785012,13.3612647 Z M42.6785012,15.6849629 C42.0650321,15.6849629 41.5677171,16.2051405 41.5677171,16.846812 C41.5677171,17.4884836 42.0650321,18.0086611 42.6785012,18.0086611 C43.2919704,18.0086611 43.7892854,17.4884836 43.7892854,16.846812 C43.7892854,16.2051405 43.2919704,15.6849629 42.6785012,15.6849629 Z",
    id: "Combined-Shape",
    fill: "#2CB5D6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(36.539958, 19.170510)",
    fill: "#D9D9D9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.92614909,5.85018528 C8.27273723,4.62221457 6.83832283,3.19218737 4.92134491,2.83933567 C3.00436699,2.48648396 2.41527006,3.36915031 0.753889194,3.0633455 C1.85660688,4.12013148 7.67689832,7.31093893 8.92614909,5.85018528 Z",
    id: "Path-26",
    transform: "translate(4.840019, 4.490513) rotate(39.000000) translate(-4.840019, -4.490513) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.36436249,5.80924552 C7.87687904,5.40394932 7.1804741,4.05296199 7.87687904,2.70197466 C8.34114899,1.80131644 9.22326192,0.90065822 10.5232178,0 C10.3375098,0.945691131 10.2446558,1.66621771 10.2446558,2.16157973 C10.2446558,2.90462276 9.89645336,5.47149869 8.36436249,5.80924552 Z",
    id: "Path-27"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.0476968,7.55201918 L40.0476968,7.27080355 C40.0476968,6.46360734 40.7020586,5.80924552 41.5092548,5.80924552 C42.316451,5.80924552 42.9708129,6.46360734 42.9708129,7.27080355 L42.9708129,15.6849629 L42.9708129,15.6849629",
    id: "Path-25",
    stroke: "#FFFFFF",
    strokeWidth: 1.48404255,
    strokeLinecap: "round"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffeeIcon);
export default __webpack_public_path__ + "static/media/coffee-icon.780e9232b8ee4652676a3226898ce74f.svg";
export { ForwardRef as ReactComponent };